import { useEffect, useState } from "react";

import { cloneDeep } from "lodash";
import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import MomSysCreateStockTakingDialog from "../dialogTypes/MomSysCreateStockTakingDialog";

function MomSysCreateStockTakingDetailButton ( props ) {

    const { id, schema, refresh, onSuccess, createButtonName, stockTakingId ,customizeErrorMsgCallback, ...others } = props;

    const [modifiedSchema, setModifiedSchema] = useState();

    const [selectMaterial, setSelectMaterial] = useState([]);

    const [ open, setOpen ] = useState(false);

    useEffect(() => {

        if(schema) {

            let modifiedSchema = cloneDeep(schema);

            for(const column of modifiedSchema.columns) {

                switch(column.name) {

                    case "stockTakingId" : 
                    case "lotNo" : 
                    case "workState" :
                    case "qty" :
                        column.hideInForm = true;
                    break;
                    case "wareHouseCode" :
                        column.hideInForm = false;
                        column.formGroup = 1;
                        column.formOrder = 10;
                    break;
                    case "jaHo":
                        column.formGroup = 1;
                        column.formOrder = 50;
                        column.disabled = false;
                    break;
                    case "price":
                        column.formGroup = 1;
                        column.formOrder = 60;
                        column.disabled = false;
                    break;
                    case "amount":
                        column.formGroup = 1;
                        column.formOrder = 70;
                        column.disabled = false;
                    break;
                    case "addInfo":
                        column.formGroup = 1;
                        column.formOrder = 80;
                        column.disabled = false;
                    break;
                    case "ptQty":
                        column.formGroup = 1;
                        column.formOrder = 90;
                        column.disabled = false;
                        break;
                    case "manufacturedDate":
                        column.formGroup = 1;
                        column.formOrder = 100;
                        column.disabled = false;
                    break;
                    case "expirationDate":
                        column.formGroup = 1;
                        column.formOrder = 120;
                        column.disabled = false;
                    break;
                    
                    default :
                        break;
                }

            }

            setModifiedSchema(modifiedSchema);

        }



    },[schema,selectMaterial])

    const onOpen = () => {

        setOpen ( true );

    };

    const onClose = () => {

        setOpen ( false );

    };

    const onCreateSuccess = ( msg ) => {

        if ( onSuccess ) {

            onSuccess ( msg );

        }

        refresh.refresh ();

    };

    const onSelectMaterial = (material) => {

        setSelectMaterial(material)

    }

    return (

        <>
            <CreateRecordButtonLayout id={id+"create-button"} onClick={onOpen} createButtonName ={createButtonName} {...others} />
            <MomSysCreateStockTakingDialog
                id={id+"create-dialog"}
                schema={modifiedSchema}
                initialData={undefined}
                open={open}
                onClose={onClose}
                onSuccess={onCreateSuccess}
                stockTakingId = {stockTakingId}
                selectMaterial = {onSelectMaterial}
            />
        </>

    );
}

export default MomSysCreateStockTakingDetailButton;

